const formatPhoneNumber = (value: string): string => {
    const digits = value.replace(/^\+1/, '').replace(/\D/g, '');
    const SlicedDigits = digits.slice(0, 10);

    let formatted = '';
    if (SlicedDigits.length > 0) {
        formatted = '(' + SlicedDigits.substring(0, 3);
    }
    if (SlicedDigits.length >= 4) {
        formatted += ') ' + SlicedDigits.substring(3, 6);
    }
    if (SlicedDigits.length >= 7) {
        formatted += '-' + SlicedDigits.substring(6, 10);
    }
    return formatted;
};

export default formatPhoneNumber;